import React from 'react'
import Button from 'components/Button'
import MetaMaskWalletIcon from 'assets/icons/wallets/wallet-metamask.svg'
import CoinbaseWalletIcon from 'assets/icons/wallets/wallet-coinbase.svg'
import WalletConnectWalletIcon from 'assets/icons/wallets/wallet-walletconnect.svg'
import TrezorWalletIcon from 'assets/icons/wallets/wallet-trezor.svg'
import SafekWalletIcon from 'assets/icons/wallets/wallet-safe.svg'
import { styles } from './styles.scss'

const WalletSelector = (props) => {
  return (
    <div className={styles}>
      <div className="wallet-selector">
        <div className="container">
          <span>Connect A Wallet</span>
          <ul>
            <li>
              <Button
                color="primary"
                size="large"
                variant="outlined"
                onClick={props.onClick}
              > 
                <img src={MetaMaskWalletIcon} />
                MetaMask
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                size="large"
                variant="outlined"
                onClick={props.onClick}
              > 
                <img src={CoinbaseWalletIcon} />
                Coinbase Wallet
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                size="large"
                variant="outlined"
                onClick={props.onClick}
              > 
                <img src={WalletConnectWalletIcon} />
                WalletConnect
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                size="large"
                variant="outlined"
                onClick={props.onClick}
              > 
                <img src={TrezorWalletIcon} />
                Trezor
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                size="large"
                variant="outlined"
                onClick={props.onClick}
              > 
                <img src={SafekWalletIcon} />
                Safe
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default WalletSelector
